import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { UserEntity } from "../user/user.entity";
@Entity('user_points')
export class UserPointsEntity {  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("int",{
    nullable:true,
    name:"user_id"
  })
  userId:number;
  @Column("int",{
    nullable: false,
    name:"points"
  })
  points:number;  
  @OneToOne(()=>UserEntity,(user:UserEntity)=>user.userpoints)
  @JoinColumn({name:'user_id'})
  user:UserEntity;
}